// polyfill
import 'promise-polyfill/src/polyfill';
import 'core-js/es/object/assign';
import 'core-js/es/array/includes';
import 'core-js/es/array/reduce';
import 'core-js/es/string/includes';
